import Storage from './localStorage';
import toAnalysisParams from '@/plugins/toAnalysisParams'
export let util = {
  getMediaDuration(url) {
    let el = new Audio();
    if (/\.(mp4|ogg)$/.test(url)) {
      el = document.createElement('video');
    }
    el.src = url;
    let loading = new Promise((resolve, reject) => {
      el.addEventListener('loadedmetadata', function h() {
        const d = el.duration || 0;
        el.removeEventListener('loadedmetadata', h);
        el.remove();
        el.srcObject = null;
        resolve(d);
      });
    })
      .catch((err) => {
        console.warn(err)
        return Promise.resolve(0)
      })

    return loading;
  },
  formatDur(sec) {
    let parts = ['00', '00'];
    if (sec > 59) {
      parts[0] = String((sec / 60) | 0).replace(/^[0-9]{1}$/, '0$&');
      parts[1] = String(Math.round(sec % 60)).replace(/^[0-9]{1}$/, '0$&');
    } else {
      parts[1] = String(Math.round(sec - 0)).replace(/^[0-9]{1}$/, '0$&');
    }
    return parts.join(':')
  },
  formatDur2(sec) {
    let parts = ['00', '00'];

    let remain = sec % 60;

    if (sec > 59) {
      parts[0] = String((sec / 60) | 0).replace(/^[0-9]{1}$/, '0$&');
      // parts[1] = String(Math.round(sec % 60)).replace(/^[0-9]{1}$/, '0$&');

    } else {
      // parts[1] = String(Math.round(sec - 0)).replace(/^[0-9]{1}$/, '0$&');
      remain = sec - 0
    }

    let int = remain | 0;
    let point = remain - int;
    let point5 = '';
    if (point > 0.25 && point < 0.75) {
      point5 = '.5';
    } else if (point >= 0.75) {
      int++;
    }
    if (int < 10) {
      int = '0' + int
    }
    parts[1] = `${int}${point5}`;

    return parts.join(':')
  },
 async debounce (fn, delay) {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.timeout = setTimeout(() => {
      fn()
    }, delay)
  },
  getNaturalSize(src) {
    let y, n;
    let loading = new Promise((done, fail) => {
      y = done;
      n = fail;
    });
    let img = new Image();
    img.src = src;
    img.addEventListener('load', () => {
      y({
        w: img.naturalWidth,
        h: img.naturalHeight
      })
    });
    img.addEventListener('error', () => {
      n({
        w: 0,
        h: 0
      })
    });
    return loading;
  },
  /**
    * 去掉首尾空格及回车产生的\r
    * @param {String} str 字符串
    */
  delSpacesOfStr(str) {
    if (/^( |[\s　])+|( |[\s　])+$/g.test(str)) {
      str = str.replace(/^( |[\s　])+|( |[\s　])+$/g, "");
    }
    return str;
  },
  /**
    * 过滤输入字符中的emoji
    */
  emojiFilter(emojireg) {
    const ranges = [
      "\ud83c[\udf00-\udfff]",
      "\ud83d[\udc00-\ude4f]",
      "\ud83d[\ude80-\udeff]"
    ];
    return emojireg && emojireg.replace(new RegExp(ranges.join("|"), "g"), "");
  },
  toAnalysisParams,
  localStorage: new Storage(window.localStorage)
};

export default {
  install: function (Vue, options) {
    Vue.prototype.$util = util;

    /** ===========
     * 全局自定义指令
     * ============
     */
    /**
     * 需要做点击上报的数据埋点。传入一个对象，3个属性为category,action,label
     */
    Vue.directive('analysis', {
      bind: () => { },
      inserted: (el, binding) => {
        el.addEventListener('click', binding.def.reportToBd.bind(null, binding));
      },
      unbind: (el, binding) => {
        el.removeEventListener('click', binding.def.reportToBd);
      },
      reportToBd(binding) {
        if (!_hmt) {
          console.log('百度统计代码加载失败');
          return;
        }
        let { category, action, label } = binding.value;
        _hmt.push(['_trackEvent', category, action, label]);
        // console.log({ category, action, label })
      }
    })

    Vue.prototype.$analysis = function (value) {
      if (!_hmt) {
        console.log('百度统计代码加载失败');
        return;
      }
      if (!value) {
        console.warn('first param falsy');
        return;
      }
      if (typeof value === 'string') {
        value = toAnalysisParams(value)
      }
      let { category, action, label } = value || {};
      _hmt.push(['_trackEvent', category, action, label]);
    }

  }
};



// WEBPACK FOOTER //
// ./src/plugins/util.js